import React from "react";
import { Outlet } from "react-router-dom";
import { RoleProvider } from "@/contexts/RoleContext";
import { useAppStore } from "@/core/store/useAppStore";
import { UserRole } from "@/services/urlService";

export const LibraryViewLayout: React.FC = () => {
  const { selectedClient } = useAppStore();

  if (!selectedClient) {
    return null;
  }

  return (
    <RoleProvider role={UserRole.ADMIN} clientId={selectedClient.id}>
      <Outlet />
    </RoleProvider>
  );
};
